module.exports = __webpack_public_path__ + "img/theme8.ad56f032.png";